import { Fragment, useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import { CircularProgress, Divider, Grid } from "@mui/material";
import TaskItem from "./TaskItem";
import EmptyState from "../../../common/core/EmptyState";
import { sortByName, sortByETA } from "../../../../common/helpers";
import moment from "moment/moment";

const useStyles = makeStyles()(
  (theme) => ({
    divider: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1.5)
    },
    loader: {
      paddingTop: "128px"
    }
  })
);

export default function TaskList(props) {
  const { showLoading, tasks, slim, emptyStateTitle, emptyStateDescription, orderTasksBy, filterTasksBy, emptyStateFilteredDescription } = props;
  const { classes } = useStyles();


  const filteredTasks = useMemo(() => {
    if (!filterTasksBy && !orderTasksBy) return tasks;

    return tasks
      .filter(
        t =>
          (filterTasksBy.length === 0 || !!filterTasksBy.find(f => f === t.state))
      )
      .sort(
        (a, b) =>
          orderTasksBy === "new" ? moment(b.execution.history?.created?.created).diff(a.execution.history?.created?.created) :
            orderTasksBy === "old" ? moment(a.execution.history?.created?.created).diff(b.execution.history?.created?.created) :
              orderTasksBy === "state_asc" ? a.state - b.state :
                orderTasksBy === "state_desc" ? b.state - a.state :
                  orderTasksBy === "driver" ? sortByName(a, b) : 
                    orderTasksBy === "eta" ? sortByETA(a,b) : 0
      )
  }, [tasks, orderTasksBy, filterTasksBy]);

  return (
    <Grid item xs={12} container>
      {
        showLoading ? (
          <Grid item xs={12} container justifyContent="center" alignItems="center" className={classes.loader}>
            <Grid item>
              <CircularProgress variant="indeterminate" size={"48px"} />
            </Grid>
          </Grid>
        ) : filteredTasks.length === 0 ? (
          <EmptyState
            title={emptyStateTitle}
            description={tasks.length === 0 ? emptyStateDescription : emptyStateFilteredDescription}
          />
        ) : filteredTasks.map((t, i) => (
          <Fragment key={i}>
            <TaskItem slim={slim} missionTask={t} />

            {i !== filteredTasks.length - 1 || slim ? (
              <Grid item xs={12}>
                <Divider className={classes.divider} />
              </Grid>
            ) : null}

          </Fragment>
        ))}

    </Grid>
  );
}